import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const OrganizationIdAlreadyTakenError = BaseErrorSchema.extend({
  errorType: z.literal('OrganizationIdAlreadyTakenError'),
  organizationId: z.string(),
});

export type OrganizationIdAlreadyTakenError = z.infer<
  typeof OrganizationIdAlreadyTakenError
>;
